<template>
<div id="register">
    <h3 class="greetingHeader">Welcome To PreEvent</h3>

    <b-container>
        <!-- Row 1: First Name and Last Name -->
        <b-row class="text-center">
            <h3  class="text-danger">Reset password failed</h3>
            <p>Oops! There was an error resetting your password. Please try again later.</p>
        </b-row>
        <!-- Row 2: Email, Password, and Re-enter Password -->


        <!-- Row 3: Register Button -->
        <b-row>
            <b-col>
                <b-button @click="navigate" class="w-100" type="submit" id="registerButton" >Try again</b-button>
            </b-col>
        </b-row>

    </b-container>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        password: '',
        passwordVisible: false,
        rePasswordVisible: false,
        rePassword: ''
        }
    }
  },  
  methods: {   
    handleSubmit() {
      // Handle form submission here
        alert(this.form.email);
    },
    navigate() {
      this.$router.push('/forgotpassword');
    }
  }
};
</script>

<style scoped>
     #register{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 1px solid #BFC7D6; 
        padding: 40px 40px 120px 40px;
        border-radius: 5px;
        font-family: "Kumbh Sans", sans-serif;
        font-weight: 600;
     }

     h1{
        font-weight: 600;
     }
     .greetingHeader{
      margin-bottom: 40px;
     }
     p{
      font-size: 12px;
      margin-bottom: 30px;
      font-family: "Kumbh Sans", sans-serif;
      font-optical-sizing: auto;
      font-weight: 600;
      font-style: normal;
      font-variation-settings:
        "YOPQ" 300;
     }
    h3{
      font-family: "Kumbh Sans", sans-serif;
      font-optical-sizing: auto;
      font-weight: 800;
      font-style: normal;
      font-variation-settings:
        "YOPQ" 300;
    }

    #email,#password{
      margin-bottom: 20px;
    }


  #registerButton{
    background-color: #23305B;
    margin: 20px auto 40px auto;
  }


 /* ---------------------for password eye icon----------------------------- */
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.password-toggle i {
  font-size: 1.25rem;
  color: black;
}

@media (min-width: 600px){
  #register{
    width: 550px;
  }
}

#loginLink{
    color: #23305B;
    text-decoration: none;
}

</style>